import React from 'react'
import isNil from 'lodash/isNil'
import { Grid } from 'semantic-ui-react'

const BaseGrid = ({
  settings,
  content: {
    gutter = '',
  },
  style,
  children,
}) => {
  const margin = isNil(gutter) || gutter === '' ? '' : -gutter
  return (
    <div style={{ ...style }}>
      <Grid style={{ margin }} {...settings} >
        {children}
      </Grid>
    </div>
  )
}

const Columns = ({
  renderElement,
  renderChildren,
  ...props,
}) => {
  return (
    renderElement(
      BaseGrid,
      {
        ...props,
        children: renderChildren(),
      },
    )
  )
}

Columns.propTypes = {}
Columns.defaultProps = {}

export default Columns



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/columns/Columns.js